// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorMessage = (err: any) =>
  (err?.message && err?.message === err?.message + '' ? err?.message : false) ||
  (err?.exception && err?.exception === err?.exception + '' ? err?.exception : false) ||
  (err?.error && err?.error === err?.error + '' ? err?.error : false) ||
  (err?.error?.messages?.common &&
  Array.isArray(err?.error?.messages?.common) &&
  err?.error?.messages?.common.length > 0
    ? err?.error?.messages?.common?.[0]
    : false) ||
  (err?.error?.msg && err?.error?.msg === err?.error?.msg + '' ? err?.error?.msg : false);
